<template lang="pug">
  app-modal(v-model="visible" :title="title" :width="500" :confirm-loading="loading" @ok="handleSubmit" @cancel="hide")
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="90")
    
      //- a-form-model-item(label="商家订单ID" prop="orderId" )
      //-   app-remote-select(v-model="model.orderId" api="/prj/brands/list" :params="params" allow-clear placeholder="请选择商家订单ID")
    
      //- a-form-model-item(label="商家订单号" prop="orderNumber" )
      //-   a-input(v-model="model.orderNumber" allow-clear :max-length="100" placeholder="请输入商家订单号")
    
      //- a-form-model-item(label="出入库单ID" prop="ticketId" )
      //-   app-remote-select(v-model="model.ticketId" api="/prj/brands/list" :params="params" allow-clear placeholder="请选择出入库单ID")
    
      //- a-form-model-item(label="出入库单号" prop="ticketNumber" )
      //-   a-input(v-model="model.ticketNumber" allow-clear :max-length="100" placeholder="请输入出入库单号")
    
      a-form-model-item(label="车辆" prop="plate" )
        app-remote-select(
          v-model="model.plate" 
          placeholder="请选择车辆"
          api="/prj/cars/list" 
          :params="params" 
          :field="{name: 'driverId', label: 'plate'}"
          allow-clear 
          @change="handleCarChange"
        )

      //- a-form-model-item(label="司机" prop="driverName" )
        a-input(:value="model.driverName" placeholder="司机姓名" readOnly)
        //- app-remote-select(
        //-   v-model="model.carId" 
        //-   placeholder="请选择车辆"
        //-   api="/prj/cars/list" 
        //-   :params="params" 
        //-   :field="{name: 'driverId', label: 'driverName'}"
        //-   allow-clear 
        //-   @change="handleCarChange"
        //- )
    
      a-form-model-item(label="司机" prop="driverId" )
        app-remote-select(v-model="model.driverId" api="/prj/crews/list" :params="params" allow-clear placeholder="请选择司机")
    
      a-form-model-item(label="搬运工" prop="porterIds" )
        app-remote-select(v-model="model.porterIds" 
          api="/sys/crews/list" :params="params"
          :field="{ name: 'id', label: 'name' }"
          allow-clear placeholder="请选择搬运工"
          mode="multiple"
          @change="handlePorterChange"
        )
    
      a-form-model-item(label="安装工" prop="installerIds" )
        app-remote-select(v-model="model.installerIds" 
          api="/sys/crews/list" :params="params"
          :field="{ name: 'id', label: 'name' }"
          allow-clear placeholder="请选择安装工"
          mode="multiple"
          @change="handleInstallerChange"
        )
    
      a-form-model-item(label="出车时间" prop="deliveryTime" )
        a-date-picker(placeholder="选择时间" v-model="model.deliveryTime" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" show-time)
    
      //- a-form-model-item(label="名称" prop="name" )
      //-   a-input(v-model="model.name" allow-clear :max-length="30" placeholder="请输入车辆名称")
            
        
</template>

<script>
import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
// import InspItemCreateAndEdit from './InspItemCreateAndEdit';

import moment from 'moment';

export default {
  name: 'CreateAndEdit',
  components: {
    // InspItemCreateAndEdit,
  },
  data() {
    return {
      visible: false,
      loading: false,
      title: '添加车辆',
      model: {
        // orderId: null,
        // orderNumber: null,
        // ticketId: null,
        // ticketNumber: null,
        carId: null,
        plate: null,
        driverId: null,
        porterIds: [],
        installerIds: [],
        deliveryTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        driverName: null,
        porterNames: [],
        installerNames: [],
      },
      rules: {
        // orderId: [{ required: true, message: '必填项' }],
        // orderNumber: [{ required: true, message: '必填项' }],
        // ticketId: [{ required: true, message: '必填项' }],
        // ticketNumber: [{ required: true, message: '必填项' }],
        carId: [{ required: true, message: '必填项' }],
        plate: [{ required: true, message: '必填项' }],
        driverId: [{ required: true, message: '必填项' }],
        // porterIds: [{ required: true, message: '必填项' }],
        // installerIds: [{ required: true, message: '必填项' }],
        // deliveryTime: [{ required: true, message: '必填项' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  mounted() {},
  methods: {
    show(model, action) {
      // this.$refs.form.resetFields();
      this.model = {
        ...this.model,
        deliveryTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        ...model,
        porterIds: model?.porterIds?.split(',') || [],
        installerIds: model?.installerIds?.split(',') || [],
      };
      this.action = action;
      this.title = model === undefined ? '添加车辆' : '编辑车辆';
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.model = {
        carId: null,
        driverId: null,
        porterIds: [],
        installerIds: [],
        deliveryTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        driverName: null,
        porterNames: [],
        installerNames: [],
      };
      // this.$refs.item.handleCancel();
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        // this.$resful('POST:/prj/orders/car-record', {
        //   orderIds: []
        // })
        this.$emit('modal-success', {
          ...this.model,
          porterIds: this.model.porterIds.join(','),
          installerIds: this.model.installerIds.join(','),
        });
        this.hide();
      }
    },
    handleCarChange(v, selection) {
      console.log(v, selection);
      const car = selection?.data?.attrs?.data;
      if (car) {
        this.model.carId = car.id;
        this.model.driverId = car.driverId;
        this.model.driverName = car.driverName;
        this.model.plate = car.plate;
        this.model.porterIds = [];
        this.model.porterNames = [];
        this.model.installerIds = [];
        this.model.installerNames = [];
      } else {
        this.model.carId = null;
        this.model.driverId = null;
        this.model.driverName = null;
        this.model.plate = null;
        this.model.porterNames = [];
        this.model.installerIds = [];
        this.model.installerNames = [];
      }
    },
    //
    handlePorterChange(v, options) {
      // console.log(options);
      this.model.porterNames = options.map((item) => item.data.attrs.data.name);
    },
    handleInstallerChange(v, options) {
      // console.log(options);
      this.model.installerNames = options.map(
        (item) => item.data.attrs.data.name,
      );
    },
  },
};
</script>

<style lang="less" scoped>
.checkbox-item {
  padding-left: 90px;
  margin: -10px 0 16px 0;
}
.insp-item-list {
}
</style>
